import styled from 'styled-components'

export const StyledHint = styled.div`
    width: 100%;
    padding: 20px 0;
`

export const StyledHintWrapper = styled.div`
    display: flex;
    align-items: center;
`

export const StyledHintCopy = styled.div`
    color: ${({ theme }) => theme.greyishBrown};
    font-size: 14px;
    font-weight: ${( { theme }) => theme.fontWeight.bold};
    margin-left: 10px;
`